import { FormControlLabel } from "@mui/material";
import { ReactElement } from "react";

export const RadioItemWrapper = (props: {
  control: ReactElement;
  label: ReactElement;
  selected: boolean;
}) => {
  const { label, selected, control } = props;
  return (
    <FormControlLabel
      sx={{
        backgroundColor: selected ? "primary.main" : "transparent",
        borderRadius: "4px",
        width: "100%",
        margin: 0,
        marginBottom: 2,

        "& .MuiButtonBase-root": {
          padding: "4px",
        },

        "& .MuiFormControlLabel-label": {
          ...(selected && {
            color: "white",
          }),
        },

        "&:hover": {
          backgroundColor: selected ? "primary.main" : "secondary.5",
        },
      }}
      control={control}
      label={label}
      slotProps={{
        typography: {
          flex: 1,
        },
      }}
    />
  );
};
